import { render, staticRenderFns } from "./ChallengeAddImageModal.vue?vue&type=template&id=2b4bbf28&"
import script from "./ChallengeAddImageModal.vue?vue&type=script&lang=js&"
export * from "./ChallengeAddImageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeAddImageModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports